import { IconButton } from 'react-native-paper';
import { useAppTheme } from '../theme';
import { useNavigation } from '@react-navigation/native';
import { Platform } from 'react-native';
import { useAppDispatch } from '../redux/hooks';
import { setWebModalShown } from '../redux/businessListSlice';
import { RootStackParamList } from '../types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

export default function AddBusinessButton() {
  const theme = useAppTheme();
  const dispatch = useAppDispatch();
  const navigation =
    useNavigation<NativeStackNavigationProp<RootStackParamList>>();

  function addButtonPress() {
    if (Platform.OS === 'web') {
      console.log('im here');
      dispatch(setWebModalShown('Add_Business'));
    } else {
      navigation.navigate('Add_Business');
    }
  }

  return (
    <IconButton
      icon="store-plus"
      mode="contained"
      onPress={addButtonPress}
      style={{
        backgroundColor: theme.colors.onBackground,
      }}
      iconColor={theme.colors.background}
    />
  );
}
